<script>
export default {
  data () {
    return {
      onlyInputNumbers: 'return event.charCode >= 48 && event.charCode <= 57'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/AppOnlyInputNumbers.vue